import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'

import { Column } from 'components/v2/Column'
import Heading from 'components/v2/Heading'
import { Row } from 'components/v2/Row'
import { IVehicleCardsFormValues } from 'features/Vehicles/types'
import { InputTags } from 'components/v2/InputTags'

const messages = defineMessages({
  tagCardsPlaceholder: {
    id: 'vehicles.form.cards.tagCards.placeholder',
    defaultMessage: 'Enter the tag id'
  },
  fuelCardsPlaceholder: {
    id: 'vehicles.form.cards.fuelCards.placeholder',
    defaultMessage: 'Enter the fuel card id'
  }
})

export const CardsForm = (): ReactElement => {
  const intl = useIntl()
  const { values, setFieldValue, handleBlur } = useFormikContext<IVehicleCardsFormValues>()

  return (
    <>
      <Heading.H4>
        <FormattedMessage id="vehicles.form.cards.title" defaultMessage="Cards" />
      </Heading.H4>
      <Row noMargin>
        <Column width="50%">
          <InputTags
            id="tagCards"
            values={values.tagCards}
            onChange={(tagCards): void => {
              setFieldValue('tagCards', tagCards)
            }}
            onBlur={handleBlur}
            placeholder={intl.formatMessage(messages.tagCardsPlaceholder)}
            label={<FormattedMessage id="vehicles.form.cards.tagCards.label" defaultMessage="Tag id" />}
            optional
          />
        </Column>
        <Column width="50%">
          <InputTags
            id="cards.fuel"
            values={values.fuelCards}
            onChange={(fuelCards): void => {
              setFieldValue('fuelCards', fuelCards)
            }}
            onBlur={handleBlur}
            placeholder={intl.formatMessage(messages.fuelCardsPlaceholder)}
            label={<FormattedMessage id="vehicles.form.cards.fuelCards.label" defaultMessage="Fuel id" />}
            optional
          />
        </Column>
      </Row>
    </>
  )
}
